import React from "react";
import "./StudentFutureSection.css";
import featureImg01 from '../assets/images/workstyles/startup-image-01.jpeg';
import featureImg02 from '../assets/images/workstyles/findwork-image-03.jpeg';
import featureImg03 from '../assets/images/student/student-future-image-01.jpeg';
import featureImg04 from '../assets/images/workstyles/findwork-image-01.jpeg';
import featureImg05 from '../assets/images/workstyles/freelance-image-04.jpeg';
import featureImg06 from '../assets/images/workstyles/freelance-image-01.jpeg';

const cards = [
  { icon: "location", tint: "green",  title: "地方から世界へ",
    desc: `<strong>好きな地元で働く</strong><br/>地方の課題解決プロダクトは世界に輸出できる！`,
    img: featureImg01 },
  { icon: "heart",    tint: "pink",   title: "不登校でも稼げばOK",
    desc: `<strong>企業はスキルを見ている</strong><br/>企業は、学歴よりもスキルを重視している。`,
    img: featureImg02 },
  { icon: "rocket",   tint: "orange", title: "高校生起業家として羽ばたく",
    desc: `<strong>若い感性で新しいビジネスを</strong><br/>学んだスキルを活かして、早い段階から起業に挑戦。`,
    img: featureImg03 },
  { icon: "building", tint: "blue",   title: "大企業で働く",
    desc: `<strong>安定した収入と働き方</strong><br/>安定した収入と働き方ができる！`,
    img: featureImg04 },
  { icon: "lightning",tint: "purple", title: "ベンチャーで働く",
    desc: `<strong>夢を追う仲間たちと</strong><br/>夢を追う仲間たちと一緒に働く！`,
    img: featureImg05 },
  { icon: "globe",    tint: "teal",   title: "フリーランスで世界中で働く",
    desc: `<strong>場所に縛られない働き方</strong><br/>家やカフェ、旅行しながらなど、自分の好きな場所で働く！`,
    img: featureImg06 },
];

const StudentFutureSection = () => {
  return (
    <section className="future" aria-labelledby="future-title">
      <div className="future__head">
        <h2 id="future-title" className="future__title">ここから広がる未来</h2>
        <p className="future__sub">あなたの選択で、無限の可能性が広がります</p>
      </div>

      <div className="future__grid">
        {cards.map((c, i) => (
          <article key={i} className="futureCard">
            <div className="futureCard__imgWrap">
              {/* ★ 画像ラッパー内に重ねる */}
              <span className={`futureCard__icon futureCard__icon--${c.tint}`} aria-hidden="true">
                <Icon name={c.icon} />
              </span>
              <img src={c.img} alt={c.title} className="futureCard__img" loading="lazy" />
            </div>

            <div className="futureCard__body">
              <h3 className="futureCard__title">{c.title}</h3>
              <p className="futureCard__desc" dangerouslySetInnerHTML={{ __html: c.desc }} />
            </div>
          </article>
        ))}
      </div>
    </section>
  );
};

function Icon({ name }) {
  const c = "currentColor";
  switch (name) {
    case "location":
      return <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true"><path fill={c} d="M12 2a7 7 0 0 0-7 7c0 5 7 13 7 13s7-8 7-13a7 7 0 0 0-7-7Zm0 9.5a2.5 2.5 0 1 1 0-5a2.5 2.5 0 0 1 0 5Z"/></svg>;
    case "heart":
      return <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true"><path fill={c} d="M12 21s-6-4.35-9-8.5C-1 6.5 5.5 2 12 9c6.5-7 13-2.5 9 3.5c-3 4.15-9 8.5-9 8.5Z"/></svg>;
    case "rocket":
      return <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true"><path fill={c} d="M12 2c-4.97 0-9 4.03-9 9c0 3 3 7 9 11c6-4 9-8 9-11c0-4.97-4.03-9-9-9Zm0 13a4 4 0 1 1 0-8a4 4 0 0 1 0 8Z"/></svg>;
    case "building":
      return <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true"><path fill={c} d="M4 22V5a2 2 0 0 1 2-2h8l6 6v13H4Zm12-10h4l-4-4v4Z"/></svg>;
    case "lightning":
      return <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true"><path fill={c} d="M11 21h-1l1-7H7l7-12h1l-1 7h4z"/></svg>;
    default: // globe
      return <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true"><path fill={c} d="M12 2a10 10 0 1 0 0 20a10 10 0 0 0 0-20Zm0 2c1.38 0 2.63.56 3.54 1.46A5 5 0 0 1 12 7a5 5 0 0 1-3.54-1.54A5 5 0 0 1 12 4Zm0 16a8 8 0 0 1-7.75-6h15.5A8 8 0 0 1 12 20Z"/></svg>;
  }
}

export default StudentFutureSection;
